<template>
  <label class="file_label" :for="id">
    <slot></slot>
    <input :id="id" type="file" :accept="accept" @change="change" />
  </label>
</template>

<script>
export default {
  props: {
    accept: String,
    onload: Function,
  },
  data() {
    return {
      id: `file_${(Math.random() + 1).toString(36).substring(7)}`,
    };
  },
  methods: {
    change(e) {
      if (!e.target.files.length) return false;
      this.onload(e.target.files[0]);
      e.target.value = "";
    },
  },
};
</script>

<style lang="scss">
.file_label {
  @include buttonEnhance();
  input[type="file"] {
    display: none !important;
  }
}
</style>
